import React from 'react'
import { Checkbox } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
export default class DailyUpdateCheckBox extends React.PureComponent {
    updateInitaitiveDailyUpdates = () => {
        if (this.props.dailyUpdates) {
            dispatch.initiatives.updateInitaitiveDailyUpdates({ id: this.props.id, dailyUpdates: false });
        }
        else {
            dispatch.initiatives.updateInitaitiveDailyUpdates({ id: this.props.id, dailyUpdates: true });
        }
    }
    render() {
        return (
            <div className="display-block">
                {/* <div className="display-flex"> */}

                <Checkbox toggle className='diamond-location pull-right' checked={this.props.dailyUpdates ? true : false} onChange={this.updateInitaitiveDailyUpdates} />
                {/* </div> */}
                <h3>Receive daily updates</h3>
                <p>You will receive an email that will help you to understand the overall progress and status of an initiative and it's activities.</p>

            </div>

        )
    }
}